import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "modal"
}
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = ["disable"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DeleteReasonDialog = _resolveComponent("DeleteReasonDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Сверка Акт", -1)),
    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "open-modal-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true))
          }, "Загрузить акт сверки")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_b_pagination, {
            modelValue: _ctx.currentPage,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
            "total-rows": _ctx.kindergartenActReconciliation?.totalElements,
            "per-page": _ctx.searchParam.countInPage
          }, null, 8, ["modelValue", "total-rows", "per-page"])
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.kindergartenActReconciliation?.content,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "#",
            width: "50"
          }),
          _createVNode(_component_el_table_column, { label: "Название файла" }, {
            default: _withCtx((scope) => [
              _createElementVNode("a", {
                onClick: ($event: any) => (_ctx.handleDownload(scope.row.report.uuid, scope.row.report.fileName)),
                class: _normalizeClass({ 'active-link': scope.row.report.reportStatus === 'GENERATED', 'error-link': scope.row.report.reportStatus === 'ERROR' })
              }, _toDisplayString(scope.row.report.fileName), 11, _hoisted_6)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Расчетный год",
            prop: "accountingYear"
          }),
          _createVNode(_component_el_table_column, { label: "Статус" }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: _normalizeClass({'uploaded-status': scope.row.status===_ctx.KindergartenActReconciliationStatus.UPLOADED, 'success-status': scope.row.status===_ctx.KindergartenActReconciliationStatus.ACCEPTED, 'error-status': scope.row.status===_ctx.KindergartenActReconciliationStatus.REJECTED})
              }, _toDisplayString(_ctx.kindergartenActReconciliationStatus(scope.row.status, scope.row.comment)), 3)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "" }, {
            default: _withCtx((scope) => [
              (scope.row.status === _ctx.KindergartenActReconciliationStatus.UPLOADED)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-danger",
                    onClick: ($event: any) => (_ctx.openDeleteDialog(scope.row.id))
                  }, "Удалить загруженный акт", 8, _hoisted_7))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_DeleteReasonDialog, {
      modelValue: _ctx.showDeleteDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDeleteDialog) = $event)),
      title: "Удалить загруженный акт?",
      loading: _ctx.deleteLoading,
      onConfirm: _ctx.removeKindergartenActReconciliation
    }, {
      default: _withCtx(() => _cache[9] || (_cache[9] = [
        _createElementVNode("p", null, "Файл акта останется в системе и может быть восстановлен администратором.", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "loading", "onConfirm"]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[12] || (_cache[12] = _createElementVNode("h4", null, "Выберите .pdf файл для загрузки Акта", -1)),
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  for: "accountingYear",
                  class: "form-label"
                }, "Расчетный год", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  min: "2024",
                  step: "1",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.accountingYear) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.accountingYear]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  for: "timesheetFile",
                  class: "form-label"
                }, "Выберите .pdf файл", -1)),
                _createElementVNode("input", {
                  type: "file",
                  id: "timesheetFile",
                  class: "form-control",
                  required: "",
                  accept: ".pdf",
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                }, null, 32)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "submit-btn",
                  disable: _ctx.isUploading
                }, _toDisplayString(_ctx.isUploading ? 'Загружается...' : 'Загрузить'), 9, _hoisted_13)
              ])
            ], 32),
            _createElementVNode("button", {
              class: "close-modal-btn",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, "Закрыть")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}